import { type SxProps, type Theme } from "@mui/material/styles";

/** `pagination/spacing`: between the range-and-items group and the page-size select. */
export const ROOT_GAP = 2.5;

/** `pagination/status/spacing` and `pagination/entries/spacing`: inside each group. */
export const GROUP_GAP = 1;

/** Wide enough for a three-digit page size beside the chevron; Figma's 60px holds two digits. */
export const PAGE_SIZE_SELECT_WIDTH = 66;

export const ROOT_SX: SxProps<Theme> = {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: ROOT_GAP,
};

export const GROUP_SX: SxProps<Theme> = { display: "flex", alignItems: "center", gap: GROUP_GAP };

export const PAGE_SIZE_SELECT_SX: SxProps<Theme> = { width: PAGE_SIZE_SELECT_WIDTH };
